module.exports = __webpack_public_path__ + "assets/img/D3-Security-Content-Marketing-w960.362b07c9.webp";